import React from "react";
import { motion } from "framer-motion";
import { Zap, Tag, Users, BadgeCheck } from "lucide-react";
import { useLang } from "@/context/Lang";
import { IMAGES } from "@/data";
import { Reveal, Overline } from "@/components/site/Reveal";

const ICONS = [Zap, Tag, Users, BadgeCheck];

export default function Manifesto() {
  const { t } = useLang();
  return (
    <section id="why" className="bg-navy grain relative py-24 md:py-32" data-testid="why">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <Reveal className="max-w-3xl mb-16">
          <Overline dark>{t.why.overline}</Overline>
          <h2 className="mt-4 font-display font-extrabold text-white text-4xl md:text-6xl leading-[0.95] tracking-tighter">
            {t.why.title}
          </h2>
        </Reveal>

        <div className="grid lg:grid-cols-[1fr_0.9fr] gap-12 lg:gap-20 items-start">
          <div className="space-y-10">
            {t.why.items.map((it, i) => {
              const Icon = ICONS[i];
              return (
                <Reveal key={i} delay={i * 0.08} className="group flex gap-6 border-b border-white/10 pb-8" data-testid={`why-item-${i}`}>
                  <span className="font-display font-black text-white/15 text-4xl md:text-5xl leading-none tracking-tighter shrink-0 w-16">
                    0{i + 1}
                  </span>
                  <div className="flex-1">
                    <div className="flex items-center gap-3">
                      <Icon size={22} className="text-orange" />
                      <h3 className="font-display font-bold text-white text-2xl tracking-tight">{it.t}</h3>
                    </div>
                    <p className="mt-3 text-white/60 leading-relaxed max-w-lg">{it.d}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>

          <Reveal delay={0.2} className="relative lg:sticky lg:top-28">
            <div className="relative border border-white/15 overflow-hidden aspect-[3/4]">
              <img src={IMAGES.manifesto} alt="Professional, licensed Seven Home Services crew working on a residential remodel" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-navy/70 to-transparent" />
            </div>
            <div className="absolute -bottom-6 -left-4 md:-left-6 bg-orange text-white p-5 md:p-6 max-w-[220px]">
              <div className="font-display font-black text-3xl md:text-4xl leading-none">100%</div>
              <div className="text-sm font-semibold mt-1 opacity-90">
                {t.why.items[3].t}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
